import { useQuery } from '@apollo/client/react';
import { useError } from 'contexts/error';
import useQueryError from 'hooks/use_query_error';

const useResourceShow = ({ query, variables, skip = false, fetchPolicy, errorKey, onError, defaultData }) => {
  const setError = useError();

  const {
    data = defaultData,
    loading,
    error,
    refetch,
  } = useQuery(query, { variables, skip, fetchPolicy });

  useQueryError(error, () => {
    if (errorKey) setError(errorKey);
    onError?.();
  });

  return { data, loading, error, refetch };
};

export default useResourceShow;
